import Cta from '@atoms/Cta/Cta';
import Text from '@atoms/Text/Text';
import { ITextContent } from '@models/ITextContent';
import SiteEnum from '@models/enums/SiteEnum';
import ThemeEnum from '@models/enums/ThemeEnum';
import classNames from 'classnames';

interface Props {
  readonly textContent: ITextContent;
  readonly site: SiteEnum;
  readonly theme: ThemeEnum;
}

const TextContent = ({
  textContent: { header, subText, ctas, trumpetText },
  site,
  theme = ThemeEnum.Light,
}: Props) => {
  const isDark = theme === ThemeEnum.Dark;
  const textClass = isDark ? 'tw-text-white' : 'tw-text-grey-80';

  return (
    <section className="tw-text-black-100 tw-flex tw-flex-col tw-gap-sm">
      <div className="tw-flex tw-flex-col tw-gap-1">
        {trumpetText && (
          <Text variant="body-small" className={textClass}>
            {trumpetText}
          </Text>
        )}
        <Text variant="headline" className={textClass}>
          {header}
        </Text>
      </div>
      {subText && (
        <div
          className={classNames(
            'tw-rich-text tw-text-grey-80',
            site === SiteEnum.B2B && '[&_p]:tw-mb-6',
            textClass
          )}
          dangerouslySetInnerHTML={{ __html: subText }}
        />
      )}

      <div className="tw-flex tw-flex-col tw-gap-3">
        {ctas?.map(({ url, target, text }) => (
          <div className="tw-inline-block" key={text}>
            <Cta
              site={site}
              url={url}
              target={target}
              text={text}
              theme={theme}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default TextContent;
